export default __webpack_public_path__ + "static/media/contact-us-mobile.fce7c264.png";